import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
//styles
import { HorizontalMargin, CountWrapper } from './style';
//ui
import { Text } from '../../UI/Text';
//components
//layouts
import { Row } from '../../Layouts';
import { Icon } from '../../Components/Icons/Icons';
import { ProfileSettingsDropDown } from '../../Components/Dropdowns';
import { UserActionCreators } from '../../../Store/ActionCreators/UserActionCreators';
import { handleLoginService } from '../../../Services/handleLocalStorage';

const CountText = ({ children, type }) => {
    return (
        <Text center medium weight={'bold'}>
            {children}
        </Text>
    );
};

const ProfileStats = ({ followers, following, workouts, repeats, classes, type, ...props }) => {
    return (
        <Row wrap={'true'} justify={'center'}>
            <HorizontalMargin>
                <CountWrapper>
                    <CountText type={type}>{followers}</CountText>
                </CountWrapper>
                <Text small opacity={0.7}>
                    Followers
                </Text>
            </HorizontalMargin>
            <HorizontalMargin>
                <CountWrapper>
                    <CountText type={type}>{following}</CountText>
                </CountWrapper>
                <Text small opacity={0.7}>
                    Following
                </Text>
            </HorizontalMargin>
            <HorizontalMargin>
                <CountWrapper>
                    <CountText type={type}>{workouts}</CountText>
                </CountWrapper>
                <Text small opacity={0.7}>
                    Workouts
                </Text>
            </HorizontalMargin>
            <HorizontalMargin>
                <CountWrapper>
                    <CountText type={type}>{repeats}</CountText>
                </CountWrapper>
                <Text small opacity={0.7}>
                    Repeats
                </Text>
            </HorizontalMargin>
            {type === 'GYM' && (
                <HorizontalMargin>
                    <CountWrapper>
                        <CountText type={type}>{classes}</CountText>
                    </CountWrapper>
                    <Text small opacity={0.7}>
                        Classes
                    </Text>
                </HorizontalMargin>
            )}
            {handleLoginService.isAuthenticated() &&
                props.profileId == handleLoginService.getUserId() && (
                    <HorizontalMargin>
                        <ProfileSettingsDropDown onAccountDelete={props.deleteUserAccount} />
                    </HorizontalMargin>
                )}
        </Row>
    );
};

const mapStateToStatsProps = ({ profile: { currentProfile } }) => ({
    followers: currentProfile.stats.followersCount,
    following: currentProfile.stats.followingCount,
    workouts: currentProfile.stats.workoutsCount,
    repeats: currentProfile.stats.repeatsCount,
    classes: currentProfile.stats.classesCount,
    profileId: currentProfile.id,
});

const mapDispatchToProps = dispatch => ({
    deleteUserAccount: () => dispatch(UserActionCreators.deleteUserAccountRequest()),
});

export default compose(
    withRouter,
    connect(
        mapStateToStatsProps,
        mapDispatchToProps,
    ),
)(ProfileStats);



// WEBPACK FOOTER //
// ./src/UI/Containers/ProfileStats/Stats.js